"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionPlansRadioGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _hooks = require("../../hooks");
var _plan = require("../../api/accessors/plan");
var _SubscriptionPlansSkeleton = require("./SubscriptionPlansSkeleton");
var _response = require("../../utils/response");
var _api = require("../../api");
var _SubscriptionRadioItem = _interopRequireDefault(require("../SubscriptionRadioItem"));
var _Translated = _interopRequireDefault(require("../Translated"));
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(() => (0, _core.createStyles)({
  couponInfo: {
    fontSize: 18,
    margin: 0,
    paddingTop: 0,
    color: '#808080'
  },
  priceAfterDiscount: {
    fontSize: 18,
    fontWeight: '500',
    display: 'inline',
    paddingRight: 8,
    marginBlock: 0
  },
  plansList: {
    gap: 12
  },
  price: {
    fontWeight: '700'
  }
}));
const SubscriptionPlansRadioGroup = props => {
  const {
    defaultSelectedPlan = null,
    fetchPlans: passedApiFetchPlans,
    onPlanChange,
    maxWidth,
    onPlansReceived = () => {},
    disabled: isDisabled = false,
    showTotalPrice: isTotalPriceShown = true
  } = props;
  const [selectedPlan, setSelectedPlan] = (0, _react.useState)(defaultSelectedPlan);
  const {
    data: plans,
    fetching: fetchingPlans,
    fetchingError: fetchingPlansError
  } = (0, _hooks.useFetchEffect)({
    apiFetchFunction: passedApiFetchPlans || _api.fetchPlans,
    transformResponse: response => {
      return Array.isArray(response) ? response : response?.[0];
    },
    onSuccess: apiPlans => {
      const defaultPlan = apiPlans.length === 1 ? apiPlans[0] : apiPlans.find(_ref => {
        let {
          is_default
        } = _ref;
        return is_default;
      });
      onPlansReceived(apiPlans);
      if (!defaultPlan || selectedPlan) {
        return;
      }
      setSelectedPlan(defaultPlan);
      onPlanChange(defaultPlan);
    }
  });
  const handlePlanChange = e => {
    const plan = plans?.find(planOption => (0, _plan.getId)(planOption) === e.target.value);
    setSelectedPlan(plan);
    onPlanChange(plan);
  };
  const classes = useStyles();
  const intl = (0, _hooks.useIntl)();
  const getSubscriptionLabel = (plan, coupon) => {
    const price = coupon?.id ? plan.price_after_discount : plan.price_with_taxes;
    const styledPrice = /*#__PURE__*/_react.default.createElement("span", {
      className: classes.price
    }, price);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _plan.getName)(plan), " (", styledPrice, ")");
  };
  (0, _react.useEffect)(() => {
    if (defaultSelectedPlan && plans) {
      setSelectedPlan(plans.find(plan => (0, _plan.getId)(plan) === (0, _plan.getId)(defaultSelectedPlan)) || null);
    }
  }, [defaultSelectedPlan, plans]);
  const renderNewPrice = () => {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: classes.couponInfo,
      "data-testid": "renewal-price"
    }, selectedPlan.coupon?.metadata?.POPUP_TEXT2 || /*#__PURE__*/_react.default.createElement(_Translated.default, {
      values: {
        priceWithTaxes: selectedPlan.price_with_taxes
      },
      id: "new_price"
    }));
  };
  const renderYearlyPrice = () => {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: classes.couponInfo,
      "data-testid": "yearly-price"
    }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
      values: {
        yearlyPrice: selectedPlan.yearly_price_with_discount || selectedPlan.yearly_price_with_taxes
      },
      id: "total_yearly_price"
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    flexDirection: "column",
    maxWidth: maxWidth,
    gridGap: 16
  }, fetchingPlans ? /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: 3
  }, /*#__PURE__*/_react.default.createElement(_SubscriptionPlansSkeleton.SubscriptionPlansSkeleton, null)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fetchingPlansError && /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    text: (0, _response.getErrorMessage)(fetchingPlansError)
  }), /*#__PURE__*/_react.default.createElement(_core.RadioGroup, {
    value: selectedPlan?.id,
    onChange: handlePlanChange,
    className: classes.plansList
  }, plans?.map(_ref2 => {
    let {
      coupon,
      ...plan
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: plan.id,
      "data-testid": "plan-item"
    }, plans?.length === 1 ? /*#__PURE__*/_react.default.createElement("p", {
      className: classes.priceAfterDiscount,
      "data-testid": "subscription-label"
    }, getSubscriptionLabel(plan, coupon)) : /*#__PURE__*/_react.default.createElement(_SubscriptionRadioItem.default, {
      plan: plan,
      label: getSubscriptionLabel(plan, coupon),
      key: `plan-item-${(0, _plan.getId)(plan)}`,
      "data-testid": "subscription-label",
      disabled: isDisabled
    }), coupon?.percent_off && /*#__PURE__*/_react.default.createElement(_core.Chip, {
      label: intl.formatMessage({
        id: 'discount'
      }, {
        percentOff: Number(coupon.percent_off).toFixed(0)
      }),
      color: "primary",
      size: "small",
      "data-testid": "discount-chip"
    }));
  })), isTotalPriceShown && selectedPlan && selectedPlan.coupon?.id && renderNewPrice(), isTotalPriceShown && selectedPlan && renderYearlyPrice()));
};
exports.SubscriptionPlansRadioGroup = SubscriptionPlansRadioGroup;